"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _jsxRuntime = require("react/jsx-runtime");
var _material = require("@mui/material");
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var options = [{
  label: 'Download as CSV',
  fileType: 'csv'
}, {
  label: 'Download as PDF',
  fileType: 'pdf'
}];
var ExportMenu = function ExportMenu(_a) {
  var exportTo = _a.exportTo,
    anchor = _a.anchor,
    onClose = _a.onClose;
  return (0, _jsxRuntime.jsx)(_material.Menu, __assign({
    anchorEl: anchor,
    open: !!(anchor !== null && anchor !== void 0 ? anchor : false),
    onClose: onClose,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  }, {
    children: options.map(function (option, idx) {
      return (0, _jsxRuntime.jsx)(_material.MenuItem, __assign({
        onClick: function onClick() {
          exportTo(option.fileType);
          onClose();
        }
      }, {
        children: option.label
      }), idx);
    })
  }));
};
var _default = ExportMenu;
exports.default = _default;